module.exports = __webpack_public_path__ + "img/contact_address_sh.a2a01b61.png";